<template>
  <div>
    <v-card class="mx-auto productStockCard" max-width="250" :loading="loading">
      <template v-slot:loader="{ isActive }">
        <v-progress-linear
          :active="isActive"
          color="deep-purple"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-img
        :src="`${product.img_path}`"
        height="200px"
        cover
        class="fitProductImage"
      ></v-img>
      <div style="text-align: left;">
        <div class="card-title bold">{{ product.name }}</div>
      </div>
      <v-divider class="mx-4 dividerCard"></v-divider>
      <v-chip-group style="text-align: left; padding: 0px; margin-left: 15px;">
        <v-chip
          >{{ $t('availableStock') }}:
          <strong style="margin-left: 3px;">
            {{ product.stock_general }}</strong
          ></v-chip
        >
        <!-- <span>
          <font-awesome-icon
            class="icon"
            icon="edit"
            @click="sendData('edit-general-stock', product)"
          />
        </span> -->
      </v-chip-group>
      <v-chip-group style="text-align: left; padding: 0px; margin-left: 15px;">
        <v-chip
          >{{ $t('stockInUnits2') }}:
          <strong style="margin-left: 3px;">
            {{ product.total_unit_stock }}</strong
          ></v-chip
        >
      </v-chip-group>
      <v-chip-group style="text-align: left; padding: 0px; margin-left: 15px;">
        <v-chip
          >{{ $t('generalStock') }}:
          <strong style="margin-left: 3px;">
            {{ product.total_stock }}</strong
          ></v-chip
        >
      </v-chip-group>
      <v-card-actions style="display: contents;">
        <v-btn
          class="checkProductUnitStock"
          v-if="product.unit_stock.length > 0"
          @click="sendData('unit-stock', product)"
        >
          {{ $t('stockInUnits2') }}
        </v-btn>
        <v-btn
          v-if="product.client"
          class="sendInquiryBtn"
          @click="openProductInquiryForm(product)"
        >
          {{ $t('sendInquiryToSupplier') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.product.id,
      baseUrl: process.env.VUE_APP_API_URL,
      loading: false
    }
  },
  methods: {
    deleteProduct(event) {
      event.preventDefault()
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('product/removeProduct', this.id)
          .then(() => {
            this.$store.dispatch('product/fetchProducts')
          })
          .catch(e => console.log(e))
      }
    },
    sendData(event, data) {
      this.$emit(event, data)
    },
    reserve() {
      this.loading = true
      setTimeout(() => (this.loading = false), 2000)
    },
    openProductInquiryForm(data) {
      this.$emit('open-product-inquiry-form', data)
      this.currentProduct = data.client
    },
    hideProductInquiryForm() {
      alert(this.$t('inquirySent'))
      this.$bvModal.hide('product-inquiry-modal')
    }
  },
  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fitProductImage {
  width: 100% !important;
  object-fit: cover !important;
}
.productStockCard {
  height: 475px !important;
  margin: 20px 10px !important;
}

.dividerCard {
  margin: 8px 16px 0px 16px !important;
}

.stock-general {
  display: inline;
}

.card-title {
  width: 235px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 10px 15px 0px 15px !important;
  text-align: left;
  font-size: 1.1rem;
  font-weight: 800;
}
.bold {
  font-weight: 700 !important;
}
.card-title {
  font-weight: 600;
  margin: auto;
}

.checkProductUnitStock {
  background-color: var(--bg-light) !important;
  border: none;
  color: var(--bright);
  box-shadow: none;
  font-weight: 600;
  margin: auto;
  margin-bottom: 10px;
}

.icon {
  font-size: 1.8em;
  padding: 5px;
  float: right;
  cursor: pointer;
}

@media only screen and (max-device-width: 769px) {
  .productStockCard {
    height: auto !important;
  }
  .sendInquiryBtn {
    margin-bottom: 10px;
  }
}

@media only screen and (max-device-width: 500px) {
  .productStockCard {
    margin: 20px auto !important;
  }
  .card-title {
    margin-top: 8px;
  }
}
@media screen and (min-width: 500px) {
  .productStockCard:hover {
    background: rgba(128, 128, 128, 0.1) !important;
    box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px,
      rgba(0, 0, 0, 0.117647) 0px 1px 4px;
    margin: 10px !important;
    transform: scale(1.03);
  }
}

@media screen and (max-width: 500px) {
  .productStockCard {
    margin: auto;
  }
  .card-title {
    width: 225px !important;
    margin-top: 10px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 359px) {
  .card-title {
    width: 240px;
    font-size: 1.2rem;
    text-align: left;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px) {
  .card-title {
    width: 270px;
  }
}
</style>
